import { Box, Stack, Typography } from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

const wrapperStyle = {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#F6F6FF',
    padding: '40px 20px',
    boxSizing: 'border-box'
};

const cardBaseStyle = {
    width: 340,
    minHeight: 320,
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E1FF',
    cursor: 'pointer',
    transition: 'transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease',
    padding: 4,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 2,
    '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 12px 28px rgba(130, 93, 252, 0.18)',
        borderColor: '#825DFC'
    },
    '&:hover .cta': {
        color: '#694ACE'
    }
};

const iconBoxStyle = {
    width: 72,
    height: 72,
    borderRadius: '50%',
    backgroundColor: '#F1ECFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

function ServiceCard({ visual, title, description, onClick }) {
    return (
        <Box
            sx={cardBaseStyle}
            onClick={onClick}
            role='button'
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClick(); }}
        >
            {visual}
            <Typography variant='h6' sx={{ fontWeight: 700, color: '#1F1B3A' }}>
                {title}
            </Typography>
            <Typography variant='body2' sx={{ color: '#5B5475', flex: 1, lineHeight: 1.6 }}>
                {description}
            </Typography>
            <Stack
                className='cta'
                direction='row'
                alignItems='center'
                spacing={0.5}
                sx={{ color: '#825DFC', mt: 1, transition: 'color 0.18s ease' }}
            >
                <Typography variant='body2' sx={{ fontWeight: 700 }}>바로가기</Typography>
                <ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />
            </Stack>
        </Box>
    );
}

export default function HomeSelection({ onSelectChat, onSelectIdea }) {
    return (
        <Box sx={wrapperStyle}>
            <Stack spacing={5} alignItems='center'>
                <Stack spacing={1} alignItems='center'>
                    <Typography variant='h4' sx={{ fontWeight: 700, color: '#1F1B3A' }}>
                        환영합니다. 무엇을 도와드릴까요?
                    </Typography>
                    <Typography variant='body1' sx={{ color: '#5B5475' }}>
                        아래에서 시작할 서비스를 선택하세요.
                    </Typography>
                </Stack>

                <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
                    <ServiceCard
                        visual={
                            <Box sx={iconBoxStyle}>
                                <ChatBubbleOutlineRoundedIcon sx={{ fontSize: 36, color: '#825DFC' }} />
                            </Box>
                        }
                        title='DARVIS 챗봇'
                        description='사내 문서 기반 채팅 화면으로 이동합니다.'
                        onClick={onSelectChat}
                    />
                    <ServiceCard
                        visual={
                            <Box
                                component='img'
                                src='/images/intro_edit.PNG'
                                alt='창의혁신아이디어'
                                sx={{ width: 'auto', height: 72, objectFit: 'contain' }}
                            />
                        }
                        title='창의혁신아이디어'
                        description='창의혁신아이디어 화면으로 이동합니다.'
                        onClick={onSelectIdea}
                    />
                </Stack>
            </Stack>
        </Box>
    );
}
